import Globals from '../../Globals';
import Query from '../../Query';
import {
	ResourceDetailReturnFields,
	ResourcesReturnFields,
	ResourceDownloadLinkReturnFields,
} from '../returnFields';

const searchResources = async function( queries, limit, skip ) {
	const queryReducer = ( constraints, query ) => {
		return [
			...constraints,
			{ categoryName_contains: query },
			{ sponsorName_contains: query },
		];
	};

	const whereClause = {
		OR: queries.reduce( queryReducer, [] ),
	};

	const { data, errors } = await this.request(
		new Query( {
			type: 'query',
			name: 'getResourcesWhere',
			params: {
				where: whereClause,
				take: limit + 1,
				skip,
			},
			returnFields: [ { resources: ResourcesReturnFields } ],
		} )
	);
	if ( errors ) return [];

	if ( data ) {
		const resources = data.data.getResourcesWhere.resources;
		let moreToLoad = false;
		if ( resources.length === Globals.itemReturnLimit + 1 ) {
			resources.pop();
			moreToLoad = true;
		}
		return { resources, moreToLoad };
	}
};

const getResourceWhere = async function( id ) {
	const where = { id };
	const { errors, data } = await this.request(
		new Query( {
			type: 'query',
			name: 'getResourceWhere',
			params: { where },
			returnFields: ResourceDetailReturnFields,
		} )
	);

	if ( errors ) {
		return { errors };
	}

	return {
		resource: data.data.getResourceWhere,
		errors: data.data.errors,
	};
};

const getResourceDownload = async function( id ) {
	const where = { id };
	const { errors, data } = await this.request(
		new Query( {
			type: 'query',
			name: 'downloadResourceWhere',
			params: { where },
			returnFields: ResourceDownloadLinkReturnFields,
		} )
	);

	if ( errors ) {
		return { errors };
	}

	return {
		downloadLink: data.data.downloadResourceWhere,
		errors: data.data.errors,
	};
};

export { searchResources, getResourceWhere, getResourceDownload };
